export default __webpack_public_path__ + "static/media/2240.1cc42808.png";